import { defineComponent, onMounted, ref, nextTick, watch, inject } from '@vue/composition-api';
import LabelAPI from 'src/api/labels';
import ProjectLabel from 'src/components/site/ProjectLabels/ProjectLabel.vue';
export default defineComponent({
    components: {
        ProjectLabel,
    },
    setup() {
        const analytics = inject('analytics');
        const emptyFormValues = {
            'name': '',
            'description': '',
            'color': '',
        };
        const predefineColors = ref([
            '#9F5151', '#CF5A5A', '#DD6D3E', '#D9AC0D', '#72BE4E', '#619572', '#36C09F', '#3E9FA5', '#44A0C8', '#0F7DBA',
            '#3F5A84', '#464ABC', '#656C7E', '#6751A6', '#707070', '#955454', '#A03E79', '#A5A5A5', '#AB69C2', '#D76293'
        ]);
        const isLoading = ref(true);
        const labels = ref([]);
        const response = ref({});
        const pageN = ref(1);
        const PAGE_SIZE = 15;
        const nameUnderEdit = ref(undefined);
        const descriptionUnderEdit = ref(undefined);
        const showDeleteModal = ref(false);
        const showCreateModal = ref(false);
        const labelToDelete = ref({});
        const createFormValues = ref(emptyFormValues);
        const formRules = {
            name: [{ required: true, message: 'Please give this label a name', trigger: 'blur' }]
        };
        // the form ref, would have been this.$refs.createForm
        const createFormRef = ref(null);
        const fetchLabels = async () => {
            isLoading.value = true;
            try {
                const res = await LabelAPI.getLabels(pageN.value, undefined, PAGE_SIZE);
                labels.value = res?.results ?? [];
                response.value = res;
            }
            finally {
                isLoading.value = false;
            }
        };
        watch(pageN, fetchLabels);
        const updateLabel = async (id, attrs) => {
            analytics?.track.labels.updateLabel(Object.keys(attrs));
            await LabelAPI.updateLabel(id, attrs);
            fetchLabels();
        };
        const deleteLabel = async (id) => {
            analytics?.track.labels.deleteLabel();
            await LabelAPI.deleteLabel(id);
            showDeleteModal.value = false;
            // Next tick so that the model text doesn't update during close
            // animation
            nextTick(() => labelToDelete.value = {});
            fetchLabels();
        };
        const createLabel = async (name, color) => {
            const label = await LabelAPI.createLabel({ name, color });
            await fetchLabels();
            const idx = labels.value.findIndex(l => l.id === label.id);
            handleNameClick(idx, `name_input_${idx}`);
            analytics?.track.labels.createdNewLabel();
        };
        const clearCreateForm = () => {
            createFormValues.value = emptyFormValues;
            if (createFormRef.value !== null)
                createFormRef.value.resetFields();
        };
        const cancelCreate = () => {
            showCreateModal.value = false;
        };
        const handleDeleteButtonClick = (label) => {
            showDeleteModal.value = true;
            labelToDelete.value = label;
        };
        const cancelDelete = () => {
            showDeleteModal.value = false;
            labelToDelete.value = {};
        };
        const handleInputConfirm = async (id, key, $event) => {
            if ($event.target !== null) {
                const value = $event.target.value;
                if (value.length === 0)
                    return;
                await updateLabel(id, { [key]: value });
            }
            nameUnderEdit.value = undefined;
            descriptionUnderEdit.value = undefined;
        };
        const handleNameClick = (tagId, inputRef) => {
            nameUnderEdit.value = tagId;
            const el = document.getElementById(inputRef);
            nextTick(() => el?.focus());
        };
        const handleDescriptionClick = (tagId, inputRef) => {
            descriptionUnderEdit.value = tagId;
            const el = document.getElementById(inputRef);
            nextTick(() => el?.focus());
        };
        onMounted(async () => {
            fetchLabels();
        });
        return {
            PAGE_SIZE,
            isLoading,
            labels,
            predefineColors,
            nameUnderEdit,
            descriptionUnderEdit,
            showDeleteModal,
            showCreateModal,
            labelToDelete,
            createFormValues,
            formRules,
            createFormRef,
            response,
            pageN,
            updateLabel,
            handleNameClick,
            handleDescriptionClick,
            handleInputConfirm,
            handleDeleteButtonClick,
            deleteLabel,
            createLabel,
            cancelDelete,
            cancelCreate,
            clearCreateForm,
        };
    }
});
